module.exports = "/_next/static/images/75605b692dce627595a7c9df50ff1705-anticipate.png.webp";